module.exports = __webpack_public_path__ + "img/view-corner.c782f158.svg";